import { type ReactNode } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Dropdown, Typography } from "antd";
import './header.scss';

export type IJournalSectionHeaderAction = {
    title: string;
    icon: ReactNode;
    onClick: () => void;
};
interface IJournalSectionHeaderProps {
  children: ReactNode;
  actionsList?:IJournalSectionHeaderAction[]
}

export const JournalSectionHeader = ({ children, actionsList }: IJournalSectionHeaderProps) => {
  const menuItems = actionsList?.map((action) => ({
    key: action.title,
    label: action.title,
    icon: action.icon,
    onClick: action.onClick,
  }));

  return (
    <div className="journal-section-header">
          <Typography.Title
              className="journal-section-header-title"
              level={3}
            >
              {children}
            </Typography.Title>
        {actionsList && actionsList.length > 0 && (
            <Dropdown 
            menu={{ items: menuItems }} 
            trigger={["click"]}>
              <MoreOutlined />
          </Dropdown>
        )}
        </div>
  );
};